import { BlocksView } from '@modules/Nzo.CMS/Frontend/libraries/cmsPage/blocks/blocks.template'
import { useInView } from '@shared/Frontend/hooks/useInView'
import { cn } from '@shared/Frontend/utils/addToClassName'
import { List } from 'immutable'
import React from 'react'
import { BlockActions } from '../shared/blockActions'
import { BlockHeader } from '../shared/blockHeader'

export const TableBlock: BlocksView['TableBlock'] = (props) => {
  const { id, table, processedTable } = props
  const { inView, ref } = useInView({ threshold: 0.1 })
  const items = { keys: table ? List(Object.keys(table.value)) : undefined }
  return (
    <section id={id} ref={ref} className={cn('block block--table ls-spacing', inView && 'inview')}>
      <div className="block__inner ls-container ls-gutter">
        <BlockHeader {...props} />

        {table && table.value && items.keys && (
          <table className="block__table table">
            {items.keys.first('') && (
              <thead>
                <tr>
                  {table.value[items.keys.first('')]?.map((x: any, i: number) => (
                    <th key={i}>{x}</th>
                  ))}
                </tr>
              </thead>
            )}

            <tbody>
              {items.keys.map((x, i) => (
                <tr key={i}>
                  {!isNaN(+x) && i != 0 && table.value[x]?.map((y: any, index: number) => <td key={index}>{y}</td>)}
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {table && table.caption && (
          <figcaption className="figure__figcaption">
            <p className="figure__caption">{table.caption}</p>
          </figcaption>
        )}
        {processedTable && <div dangerouslySetInnerHTML={{ __html: processedTable.html }} />}

        <BlockActions {...props} datalayerCategory="table_block" />
      </div>
    </section>
  )
}
